import state from './state';
import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const module = {
  state: { ...state },
  actions,
  getters,
  mutations,
};

export default { module };



// WEBPACK FOOTER //
// ./src/app/edit-page/store/index.js